import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Headroom from 'react-headroom';
import classNames from 'classnames';
import CrisisInformationBar from '../CrisisInformationBar';
import Navigation from '../Navigation';
import NavigationMobile from '../NavigationMobile';
import s from './Header.module.scss';

const Header = ({ navigation, crisisInformation }) => {
    const [isDisabled, setIsDisabled] = useState(false);
    const handleDisable = useCallback(
        () => setIsDisabled((isDisabled) => !isDisabled),
        []
    );
    const classes = classNames(
        s['Root'],
        { ['Headroom--Sticky']: isDisabled } // for global headroom styling
    );

    return (
        <>
            <Headroom
                className={classes}
                disableInlineStyles={true}
                tag="header">
                <div className={s['Root__Navigation']}>
                    <Navigation {...navigation} />
                </div>
                <div className={s['Root__NavigationMobile']}>
                    <NavigationMobile
                        {...navigation}
                        handleDisable={handleDisable}
                    />
                </div>
                <CrisisInformationBar {...crisisInformation} />
            </Headroom>
        </>
    );
};

Header.propTypes = {
    navigation: PropTypes.object,
    crisisInformation: PropTypes.object,
};

export default Header;
